import React from "react";
import { Popover } from "@headlessui/react";
import Heroicon from "../Heroicon";

function TextInput({
  value,
  name,
  title,
  handleChange,
  tooltip = null,
  showLabel = false,
  required = false,
  className,
}) {
  return (
    <div>
      <label
        htmlFor={name}
        className={`${
          !showLabel ? "sr-only" : "flex items-center text-gray-700 relative"
        }`}
      >
        {title}
        {tooltip && (
          <Popover className="relative flex-1">
            <Popover.Button
              className="block ml-2 text-gray-400 rounded-full"
              aria-label="Info"
            >
              <Heroicon icon="o-information-circle" style="w-5 h-5 mr-1" />
            </Popover.Button>
            <Popover.Panel className="absolute z-10 px-3 py-2 text-sm text-white bg-gray-700 rounded shadow">
              <p>{tooltip}</p>
            </Popover.Panel>
          </Popover>
        )}
      </label>
      <input
        value={value}
        name={name}
        id={name}
        type="text"
        placeholder={name === "website" ? "https://" : ""}
        onChange={handleChange}
        maxLength={name === "podcast_slug" ? "63" : ""}
        className={`input bg-gray-50 ${showLabel ? "mt-1" : "m-0"} ${
          name === "podcast_slug"
            ? "rounded-r-none focus:ring-0 focus:border-gray-300"
            : ""
        } ${className}`}
      />
      {value === "" && required && (
        <p className="flex items-center mt-2 text-sm text-red-600">
          <Heroicon icon="o-exclamation-circle" style="w-5 h-5 mr-1" />
          This field can&apos;t be empty.
        </p>
      )}
    </div>
  );
}

export default TextInput;
